import * as React from 'react';
import styled from 'styled-components';
import ErrorDescription from './ErrorDescription';

const ErrorImage = styled.img`
    width: 40vw;
    max-width: 143px;
    min-width: 123px;
`

const NotFound : React.SFC = () => (
  <ErrorDescription title="Looks like you took a wrong turn..." description="Nothing interesting here">
    <ErrorImage src={'https://home-web.azureedge.net/home-web-resources/not-found-direction.svg'} />
  </ErrorDescription>
);

export default NotFound;


// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/ErrorPages/components/NotFound.tsx